import React from "react";
import CurrencyComponent from "@/components/currencyComponent";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import { DepositBonus, isFunBonus } from "./depositBonus";

export function DepositBonusSuffix({ bonus }: { bonus?: DepositBonus }) {
  const { t } = useTranslationPlus("Wallet");
  if (!bonus?.amount) return null;

  return (
    <div className="suffix">
      <label>{t("Extra")}：</label>
      <span>
        +
        <CurrencyComponent
          amount={bonus.amount}
          currencyType={bonus.currencyType}
          showUnit={false}
        />
      </span>
    </div>
  );
}

export default function DepositBonusAmount({ bonus, minimum, label }: {
  bonus?: DepositBonus;
  minimum?: DepositBonus;
  label?: string;
}) {
  const { t } = useTranslationPlus("Wallet");
  if (bonus?.amount) {
    return (
      <div className="bonus-amount">
        <span className="tips">{label || t("SpecialBonus")}：</span>
        <span className="sympole">+</span>
        <CurrencyComponent
          amount={bonus.amount}
          currencyType={bonus.currencyType}
          showUnit={isFunBonus(bonus)}
          unitPosition="rt"
          className="amount"
        />
      </div>
    );
  }

  if (!minimum) return null;
  return (
    <div className="bonus-amount">
      <div className="min-recharge-group">
        <span className="tips-min">{t("MinRecharge")}</span>
        <CurrencyComponent
          className="min-amount"
          amount={minimum.amount}
          currencyType={minimum.currencyType}
          showUnit={false}
        />
      </div>
      <span className="end-tips">{t("GetBonus")}</span>
    </div>
  );
}
